function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import { compose, withHandlers, withProps, withPropsOnChange, withStateHandlers, setPropTypes } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import QuestionPreview from "./QuestionPreview";
import DropdownSelect from "../../../../../components/core/input/DropdownSelect";
import InputMultiCheckbox from "../../../../../components/core/input_v2/InputMultiCheckbox";
import TextAreaInput from "../../../../../components/core/input/TextAreaInput";
import TextInput from "../../../../../components/core/input/TextInput";
import { getSingleApplicationRequirementAction, patchApplicationRequirementApproveAnswerAction, patchApplicationRequirementDisapproveAnswerAction, patchApplicationRequirementAnswerStatusNoteAction } from "../../../../../api/jsonapi";
import handleApiErrorResponse from "../../../../../util/handleApiErrorResponse";
import { capitalize, raiseErrorMessage, raiseSuccessMessage } from '@applyboard/ui-utils';
import UrlPreview from "../UrlPreview";
// eslint-disable-line import/no-unresolved

var accepted = 'approved';
var rejected = 'disapproved';
var questionBuilder = function questionBuilder(question) {
  var labelText = "".concat(question.questionNum, ". ").concat(capitalize(question.question));
  var questionComponent = null;
  var questionInputProps = {
    inputValue: question.answer.answer,
    labelText: labelText,
    options: null,
    disabled: true
  };
  switch (question.question_format) {
    case 'short_answer':
      questionComponent = TextInput;
      break;
    case 'long_answer':
      questionComponent = TextAreaInput;
      break;
    case 'checkboxes':
      questionComponent = InputMultiCheckbox;
      questionInputProps.options = question.options.map(function (o) {
        return {
          label: capitalize(o),
          value: o
        };
      });
      questionInputProps.input = {
        value: question.answer && question.answer.answer || []
      };
      break;
    case 'dropdown':
      questionComponent = DropdownSelect;
      questionInputProps.options = question.options.map(function (o) {
        return {
          label: capitalize(o),
          value: o
        };
      });
      break;
    case 'number':
    case 'date':
      questionComponent = TextInput;
      break;
    case 'url':
      questionComponent = UrlPreview;
      break;
    default:
      break;
  }
  if (!questionComponent) {
    console.warn('cannot resolve a component for question type ', question.question_format);
    console.warn(question);
  }
  return {
    questionComponent: questionComponent,
    questionInputProps: questionInputProps
  };
};
var enhancer = compose(withProps(function (_ref) {
  var question = _ref.question;
  return questionBuilder(question);
}), connect(null, function (dispatch, _ref2) {
  var question = _ref2.question;
  return {
    updateQuestionStatusStoreAction: function updateQuestionStatusStoreAction(question_data) {
      return dispatch({
        type: 'UPDATE_ANSWER_STATUS',
        data: question_data,
        id: question.id
      });
    },
    dispatch: dispatch
  };
}), withStateHandlers(function (_ref3) {
  var _options;
  var question = _ref3.question;
  return {
    showRejectionReasonInput: question.status === rejected,
    acceptOrRejectInputProps: {
      inputId: "accept-reject-question-".concat(question.id),
      inputValue: question.status,
      onChange: function onChange() {
        return {};
      },
      options: (_options = {}, _defineProperty(_options, accepted, 'Accepted'), _defineProperty(_options, rejected, 'Rejected'), _options),
      required: false
    },
    rejectionReason: question.status === rejected ? question.answer.status_note : '',
    questionStatus: question.status,
    rejectionReasonLoading: false,
    disabledBtn: true
  };
}, {
  setShowRejectionReasonInput: function setShowRejectionReasonInput() {
    return function () {
      return {
        showRejectionReasonInput: true
      };
    };
  },
  hideRejectionReasonInput: function hideRejectionReasonInput() {
    return function () {
      return {
        showRejectionReasonInput: false
      };
    };
  },
  updateAcceptOrRejectInputProps: function updateAcceptOrRejectInputProps() {
    return function (inputProps) {
      return {
        acceptOrRejectInputProps: _objectSpread({}, inputProps)
      };
    };
  },
  setRejectionReason: function setRejectionReason() {
    return function (rejectionReason) {
      return {
        rejectionReason: rejectionReason
      };
    };
  },
  setQuestionStatus: function setQuestionStatus() {
    return function (quesionStatus) {
      return {
        quesionStatus: quesionStatus
      };
    };
  },
  setRejectionReasonLoading: function setRejectionReasonLoading() {
    return function (rejectionReasonLoading) {
      return {
        rejectionReasonLoading: rejectionReasonLoading
      };
    };
  },
  setDisabledBtn: function setDisabledBtn() {
    return function (disabledBtn) {
      return {
        disabledBtn: disabledBtn
      };
    };
  }
}), withHandlers({
  onAccept: function onAccept(_ref4) {
    var dispatch = _ref4.dispatch,
      requirement = _ref4.requirement,
      question = _ref4.question,
      setRejectionReason = _ref4.setRejectionReason,
      setDisabledBtn = _ref4.setDisabledBtn,
      updateAcceptOrRejectInputProps = _ref4.updateAcceptOrRejectInputProps,
      acceptOrRejectInputProps = _ref4.acceptOrRejectInputProps,
      setRejectionReasonLoading = _ref4.setRejectionReasonLoading,
      setShowRejectionReasonInput = _ref4.setShowRejectionReasonInput,
      updateQuestionStatusStoreAction = _ref4.updateQuestionStatusStoreAction,
      onSuccess = _ref4.onSuccess;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var questionResponse;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            questionResponse = null;
            if (!question) {
              _context.next = 29;
              break;
            }
            if (!(question.status === accepted)) {
              _context.next = 6;
              break;
            }
            if (question.answer.application_question_status === accepted) {
              raiseErrorMessage('Cannot approve more than one answer to the same question');
            } else {
              raiseSuccessMessage("Approved question ".concat(question.questionNum));
              updateAcceptOrRejectInputProps(_objectSpread(_objectSpread({}, acceptOrRejectInputProps), {}, {
                inputValue: accepted
              }));
              setRejectionReason('');
              setDisabledBtn(true);
            }
            _context.next = 27;
            break;
          case 6:
            setRejectionReasonLoading(true);
            updateAcceptOrRejectInputProps(_objectSpread(_objectSpread({}, acceptOrRejectInputProps), {}, {
              inputValue: accepted
            }));
            _context.prev = 8;
            _context.next = 11;
            return dispatch(patchApplicationRequirementApproveAnswerAction({
              application_requirement_id: requirement.id,
              question_id: question.id,
              id: question.answer.id
            }, {}));
          case 11:
            questionResponse = _context.sent;
            if (questionResponse) {
              updateQuestionStatusStoreAction(questionResponse.body.data);
            }
            setRejectionReason('');
            setDisabledBtn(true);
            raiseSuccessMessage("Approved question ".concat(question.questionNum));
            onSuccess();
            setRejectionReasonLoading(false);
            _context.next = 27;
            break;
          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](8);
            setRejectionReasonLoading(false);
            updateAcceptOrRejectInputProps(_objectSpread(_objectSpread({}, acceptOrRejectInputProps), {}, {
              inputValue: question.status
            }));
            if (question.status === rejected) {
              setShowRejectionReasonInput();
            }
            console.error(_context.t0);
            handleApiErrorResponse(_context.t0);
          case 27:
            _context.next = 30;
            break;
          case 29:
            console.error('trying to run onAccept with no question object');
          case 30:
            return _context.abrupt("return", questionResponse);
          case 31:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[8, 20]]);
    }));
  },
  onReject: function onReject(_ref6) {
    var dispatch = _ref6.dispatch,
      requirement = _ref6.requirement,
      question = _ref6.question,
      rejectionReason = _ref6.rejectionReason,
      setRejectionReasonLoading = _ref6.setRejectionReasonLoading,
      updateQuestionStatusStoreAction = _ref6.updateQuestionStatusStoreAction,
      onSuccess = _ref6.onSuccess;
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var questionResponse, getRequirementResponse;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            questionResponse = null;
            if (!question) {
              _context2.next = 49;
              break;
            }
            if (!(!rejectionReason || typeof rejectionReason !== 'string' || rejectionReason.trim() === '')) {
              _context2.next = 6;
              break;
            }
            raiseErrorMessage('Please provide a reason for rejection');
            _context2.next = 47;
            break;
          case 6:
            if (!(question.status === rejected && question.status_note === rejectionReason)) {
              _context2.next = 10;
              break;
            }
            // was already rejected and status_note has not changed, just show a toastr
            raiseSuccessMessage("Rejected question ".concat(question.questionNum));
            _context2.next = 47;
            break;
          case 10:
            if (!(question.status === rejected && question.status_note !== rejectionReason)) {
              _context2.next = 28;
              break;
            }
            // was already reject but status_note has changed, just update the note
            setRejectionReasonLoading(true);
            _context2.prev = 12;
            _context2.next = 15;
            return dispatch(patchApplicationRequirementAnswerStatusNoteAction({
              application_requirement_id: requirement.id,
              question_id: question.id,
              id: question.answer.id
            }, {
              data: {
                attributes: {
                  status_note: rejectionReason
                }
              }
            }));
          case 15:
            questionResponse = _context2.sent;
            if (questionResponse) {
              updateQuestionStatusStoreAction(questionResponse.body.data);
            }
            raiseSuccessMessage("Updated rejection reason for question ".concat(question.questionNum));
            onSuccess();
            setRejectionReasonLoading(false);
            _context2.next = 26;
            break;
          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](12);
            setRejectionReasonLoading(false);
            handleApiErrorResponse(_context2.t0);
          case 26:
            _context2.next = 47;
            break;
          case 28:
            setRejectionReasonLoading(true);
            _context2.prev = 29;
            _context2.next = 32;
            return dispatch(patchApplicationRequirementDisapproveAnswerAction({
              application_requirement_id: requirement.id,
              question_id: question.id,
              id: question.answer.id
            }, {
              data: {
                attributes: {
                  status_note: rejectionReason
                }
              }
            }));
          case 32:
            questionResponse = _context2.sent;
            if (questionResponse) {
              updateQuestionStatusStoreAction(questionResponse.body.data);
            }
            _context2.next = 36;
            return dispatch(getSingleApplicationRequirementAction({
              id: requirement.id
            }));
          case 36:
            getRequirementResponse = _context2.sent;
            dispatch({
              type: 'UPDATE_REQUIREMENT_STATUS',
              data: getRequirementResponse.body.data
            });
            raiseSuccessMessage("Rejected question ".concat(question.questionNum));
            onSuccess();
            setRejectionReasonLoading(false);
            _context2.next = 47;
            break;
          case 43:
            _context2.prev = 43;
            _context2.t1 = _context2["catch"](29);
            setRejectionReasonLoading(false);
            handleApiErrorResponse(_context2.t1);
          case 47:
            _context2.next = 50;
            break;
          case 49:
            console.error('trying to run onReject with no question object');
          case 50:
            return _context2.abrupt("return", questionResponse);
          case 51:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[12, 22], [29, 43]]);
    }));
  }
}), withHandlers({
  onAcceptOrReject: function onAcceptOrReject(_ref8) {
    var acceptOrRejectInputProps = _ref8.acceptOrRejectInputProps,
      onAccept = _ref8.onAccept,
      setShowRejectionReasonInput = _ref8.setShowRejectionReasonInput,
      setQuestionStatus = _ref8.setQuestionStatus,
      showRejectionReasonInput = _ref8.showRejectionReasonInput,
      hideRejectionReasonInput = _ref8.hideRejectionReasonInput,
      updateAcceptOrRejectInputProps = _ref8.updateAcceptOrRejectInputProps;
    return function (event) {
      setQuestionStatus(event.target.value);
      switch (event.target.value) {
        case accepted:
          if (showRejectionReasonInput) {
            hideRejectionReasonInput();
          }
          onAccept();
          break;
        case rejected:
          setShowRejectionReasonInput();
          updateAcceptOrRejectInputProps(_objectSpread(_objectSpread({}, acceptOrRejectInputProps), {}, {
            inputValue: rejected
          }));
          break;
        default:
          break;
      }
    };
  }
}), withProps(function (_ref9) {
  var acceptOrRejectInputProps = _ref9.acceptOrRejectInputProps,
    onAcceptOrReject = _ref9.onAcceptOrReject;
  return {
    acceptOrRejectInputProps: _objectSpread(_objectSpread({}, acceptOrRejectInputProps), {}, {
      onChange: onAcceptOrReject
    })
  };
}), withPropsOnChange(function (props, nextProps) {
  return props.question && nextProps.question && props.question.status !== nextProps.question.status;
}, function (_ref10) {
  var acceptOrRejectInputProps = _ref10.acceptOrRejectInputProps,
    question = _ref10.question,
    updateAcceptOrRejectInputProps = _ref10.updateAcceptOrRejectInputProps,
    setDisabledBtn = _ref10.setDisabledBtn;
  var newProps = _objectSpread(_objectSpread({}, acceptOrRejectInputProps), {}, {
    inputValue: question.status
  });
  updateAcceptOrRejectInputProps(newProps);
  setDisabledBtn(true);
}), withHandlers({
  submitRejectionOnEnterKey: function submitRejectionOnEnterKey(_ref11) {
    var onReject = _ref11.onReject;
    return function (event) {
      if (event.keyCode !== 13) {
        return;
      }
      onReject();
    };
  },
  onChangeRejectionReason: function onChangeRejectionReason(_ref12) {
    var setRejectionReason = _ref12.setRejectionReason,
      setDisabledBtn = _ref12.setDisabledBtn;
    return function (event) {
      setRejectionReason(event.target.value);
      setDisabledBtn(false);
    };
  },
  submitRejectionOnSave: function submitRejectionOnSave(_ref13) {
    var onReject = _ref13.onReject;
    return function (e) {
      e.preventDefault();
      onReject();
    };
  }
}), withProps(function (_ref14) {
  var rejectionReason = _ref14.rejectionReason,
    question = _ref14.question,
    submitRejectionOnEnterKey = _ref14.submitRejectionOnEnterKey,
    onChangeRejectionReason = _ref14.onChangeRejectionReason,
    submitRejectionOnSave = _ref14.submitRejectionOnSave,
    disabledBtn = _ref14.disabledBtn;
  var rejectionReasonInputProps = {
    disabled: true,
    labelText: '',
    onChange: onChangeRejectionReason,
    onSubmit: submitRejectionOnSave,
    onKeyDown: submitRejectionOnEnterKey,
    placeholder: 'Enter rejection reason; Press Enter to save',
    inputValue: rejectionReason,
    className: 'reject-reason-input',
    disabledBtn: disabledBtn
  };
  var rejectionReasonBtnProps = {
    disabled: disabledBtn,
    onClick: submitRejectionOnSave
  };
  if (question) {
    rejectionReasonInputProps.disabled = false;
    rejectionReasonInputProps.inputId = "rejection-reason-".concat(question.id);
  }
  if (rejectionReason === '') rejectionReasonBtnProps.disabled = true;
  return {
    rejectionReasonInputProps: rejectionReasonInputProps,
    rejectionReasonBtnProps: rejectionReasonBtnProps
  };
}), setPropTypes({
  questionComponent: PropTypes.func,
  questionInputProps: PropTypes.object,
  questionStatus: PropTypes.string,
  acceptOrRejectInputProps: PropTypes.object,
  showRejectionReasonInput: PropTypes.bool,
  rejectionReasonInputProps: PropTypes.object,
  hideRejectionReasonInput: PropTypes.func,
  onAccept: PropTypes.func,
  onAcceptOrReject: PropTypes.func,
  onChangeRejectionReason: PropTypes.func,
  onReject: PropTypes.func,
  question: PropTypes.object,
  questionNum: PropTypes.number,
  rejectionReason: PropTypes.string,
  requirement: PropTypes.object,
  setQuestionStatus: PropTypes.func,
  setRejectionReason: PropTypes.func,
  setDisabledBtn: PropTypes.func,
  setShowRejectionReasonInput: PropTypes.func,
  submitRejectionOnEnterKey: PropTypes.func,
  submitRejectionOnSave: PropTypes.func,
  updateAcceptOrRejectInputProps: PropTypes.func,
  onSuccess: PropTypes.func
}));
export default enhancer(QuestionPreview);